"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _tpmProductIntl = require("@tencent/tpm-product-intl");
var _reportUtil = require("../../utils/reportUtil");
var _componentUtils = require("../../common/componentUtils");
var _HTMLRenderer = _interopRequireDefault(require("../../common/components/HTMLRenderer"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 *
 * @description TpmResource
 * @author xlongjiang
 * @created 2025-11-10 01:47:43
 */

const Row = _tpmProductIntl.Grid.Row,
  Col = _tpmProductIntl.Grid.Col;

/**
 * 格式化组件数据
 * @param properties 组件属性
 * @param options 选项
 * @returns 格式化后的数据
 */
const formatTpmResourceData = (properties, options = {}) => {
  const _ref = properties || {},
    _ref$porintId = _ref.porintId,
    porintId = _ref$porintId === void 0 ? '' : _ref$porintId,
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? '' : _ref$tag,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$desc = _ref.desc,
    desc = _ref$desc === void 0 ? '' : _ref$desc,
    _ref$bg = _ref.bg,
    bg = _ref$bg === void 0 ? 'default' : _ref$bg,
    _ref$bgColor = _ref.bgColor,
    bgColor = _ref$bgColor === void 0 ? '' : _ref$bgColor,
    _ref$bgImg = _ref.bgImg,
    bgImg = _ref$bgImg === void 0 ? '' : _ref$bgImg,
    _ref$itemList = _ref.itemList,
    itemList = _ref$itemList === void 0 ? [] : _ref$itemList,
    _ref$openText = _ref.openText,
    openText = _ref$openText === void 0 ? '' : _ref$openText,
    _ref$packText = _ref.packText,
    packText = _ref$packText === void 0 ? '' : _ref$packText,
    _ref$docTitle = _ref.docTitle,
    docTitle = _ref$docTitle === void 0 ? '' : _ref$docTitle,
    _ref$columns = _ref.columns,
    columns = _ref$columns === void 0 ? 3 : _ref$columns,
    _ref$docList = _ref.docList,
    docList = _ref$docList === void 0 ? [] : _ref$docList;
  const handleItemList = itemList.map((item, index) => {
    const icon = item.icon,
      title = item.title,
      _item$desc = item.desc,
      desc = _item$desc === void 0 ? '' : _item$desc,
      btnText = item.btnText,
      btnHref = item.btnHref,
      img = item.img;
    const btnExtendProps = {
      'report-event': 'click_Resource_item_btn',
      'report-ext1': index,
      'report-ext2': btnText || '',
      'report-ext3': btnHref || '',
      target: '_blank'
    };
    return {
      icon: (0, _componentUtils.doComponentsUploadEvent)(icon || '').url,
      title: title ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
        html: title
      }) : '',
      desc,
      btn: btnText && btnHref ? /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
        icon: true,
        href: btnHref,
        type: 'weak-hole',
        align: "center"
      }, btnExtendProps), btnText) : null,
      img: (0, _componentUtils.doComponentsUploadEvent)(img || '').url
    };
  });
  const handleDocList = docList.map((item, index) => {
    const title = item.title,
      desc = item.desc,
      _item$linkList = item.linkList,
      linkList = _item$linkList === void 0 ? [] : _item$linkList,
      _item$bg = item.bg,
      bg = _item$bg === void 0 ? 'purple' : _item$bg;
    const handleLinks = linkList.map((item, key) => {
      const text = item.text,
        href = item.href;
      const linkExtendProps = {
        'report-event': 'click_doc_panel_link',
        'report-ext1': index,
        'report-ext2': key,
        'report-ext3': text || '',
        target: '_blank'
      };
      return /*#__PURE__*/React.createElement(_tpmProductIntl.Link, Object.assign({
        href: href
      }, linkExtendProps, {
        key: key
      }), text);
    });
    return {
      title,
      desc,
      links: handleLinks,
      bg
    };
  });
  return {
    porintId,
    tag,
    title: title ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: title
    }) : '',
    desc: desc ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: desc
    }) : '',
    bg,
    bgColor,
    bgImg: (0, _componentUtils.doComponentsUploadEvent)(bgImg || '').url,
    itemList: !!itemList.length ? handleItemList : null,
    openText,
    packText,
    docTitle,
    columns,
    docList: !!docList.length ? handleDocList : null
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} "数据"表单内容
  style,
  // {object} "样式"表单内容
  commonStyle,
  // {object} "组件自定义样式"表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatTpmResourceDat = formatTpmResourceData(data, {
        domains
      }),
      porintId = _formatTpmResourceDat.porintId,
      tag = _formatTpmResourceDat.tag,
      title = _formatTpmResourceDat.title,
      desc = _formatTpmResourceDat.desc,
      bg = _formatTpmResourceDat.bg,
      bgColor = _formatTpmResourceDat.bgColor,
      bgImg = _formatTpmResourceDat.bgImg,
      itemList = _formatTpmResourceDat.itemList,
      openText = _formatTpmResourceDat.openText,
      packText = _formatTpmResourceDat.packText,
      docTitle = _formatTpmResourceDat.docTitle,
      columns = _formatTpmResourceDat.columns,
      docList = _formatTpmResourceDat.docList;
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: porintId,
      className: `gems-materials-qci____newUI-TpmResource`
    }, (0, _reportUtil.reportShow)(['show_newUI_TpmResource', componentKey, title || ''])), /*#__PURE__*/React.createElement(_tpmProductIntl.Section, {
      tag: tag,
      title: title,
      desc: desc,
      bg: bg,
      bgColor: bgColor,
      bgImg: bgImg
    }, /*#__PURE__*/React.createElement(_tpmProductIntl.Resource, {
      itemList: itemList,
      openText: openText,
      packText: packText
    }), docList && !!docList.length && /*#__PURE__*/React.createElement(_tpmProductIntl.Panel, {
      title: docTitle
    }, /*#__PURE__*/React.createElement(Row, {
      gap: 20,
      gutter: 4
    }, docList.map((item, index) => /*#__PURE__*/React.createElement(Col, {
      span: 24 / columns,
      pad: 24,
      phone: 24,
      key: index
    }, /*#__PURE__*/React.createElement(_tpmProductIntl.DocPanel, item)))))));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}